var _circle, _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJournalIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.6924,
    r: 20,
    fill: "url(#paint0_linear_396_2443)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.692383,
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint1_linear_396_2443)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6418 18.7587C20.6418 18.0249 22.2913 15.6159 23.3564 15.6159H27.0696V11.6517C27.0696 11.2972 26.7824 11.0095 26.4268 11.0095H14.7141C13.182 11.0095 11.3574 11.7158 11.3574 15.0801V25.0802C11.3574 25.8024 11.4415 26.4016 11.5881 26.8976C11.599 26.9776 11.6241 27.0527 11.6612 27.1214C12.243 28.7516 13.5619 29.1508 14.7141 29.1508H26.4267C26.6914 29.1508 26.9272 28.9875 27.024 28.7407C27.1208 28.4939 27.0548 28.2125 26.8599 28.0333C26.8528 28.0268 26.1999 27.4148 26.1889 26.6337C26.1824 26.1679 26.4133 25.7046 26.8746 25.256C26.876 25.2553 26.8771 25.2546 26.876 25.2546C26.876 25.254 26.8773 25.2533 26.8773 25.2533C26.8773 25.2533 26.878 25.2533 26.8787 25.2526L26.8793 25.2519L26.88 25.2506C26.8921 25.2385 26.9037 25.2269 26.914 25.2142C26.9146 25.2135 26.9146 25.2135 26.9146 25.2128C26.9153 25.2128 26.9153 25.2122 26.916 25.2115C27.0063 25.1064 27.0628 24.9719 27.0691 24.8244C27.0691 24.8123 27.0698 24.8013 27.0698 24.7891V21.9013H23.3566C22.2913 21.9017 20.6418 19.4927 20.6418 18.7589L20.6418 18.7587ZM25.1925 27.8644H14.714C13.7606 27.8644 13.1658 27.505 12.8697 26.704C12.8978 25.7254 13.3446 25.4358 15.8202 25.4358H25.1692C24.9839 25.8298 24.8956 26.2406 24.9039 26.6648C24.9128 27.1172 25.0339 27.5236 25.1929 27.8644H25.1925Z",
    fill: "url(#paint2_linear_396_2443)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7847 16.4724H23.3571C22.8835 16.4724 21.5 18.3649 21.5 18.7576C21.5 19.1505 22.8835 21.0428 23.3571 21.0428H27.7847C28.2576 21.0428 28.6414 20.6584 28.6414 20.1854V17.3301C28.6414 16.8572 28.2583 16.4725 27.7847 16.4725V16.4724ZM24.392 19.8293C23.7999 19.8293 23.3205 19.3499 23.3205 18.7578C23.3205 18.1657 23.7999 17.6862 24.392 17.6862C24.9841 17.6862 25.4635 18.1657 25.4635 18.7578C25.4635 19.3499 24.9841 19.8293 24.392 19.8293Z",
    fill: "url(#paint3_linear_396_2443)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_396_2443",
    x1: 4.44444,
    y1: 34.7665,
    x2: 40,
    y2: 14.2726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF939C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC7CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_396_2443",
    x1: 35.8025,
    y1: 8.77977,
    x2: 5.18518,
    y2: 37.6687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0B2E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_396_2443",
    x1: 12.7042,
    y1: 27.7917,
    x2: 31.8854,
    y2: 14.4957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC75B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA94D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_396_2443",
    x1: 22.1121,
    y1: 20.7004,
    x2: 27.1463,
    y2: 14.4049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC75B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA94D2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalIconNew);
export default __webpack_public_path__ + "static/media/JournalIconNew.d9a62a066cf2fbb2d6647436ee86ab58.svg";
export { ForwardRef as ReactComponent };